import { createSelector } from '@reduxjs/toolkit';
import { selectIsFirstFloor } from 'shared/selectors/jsonQuery';

export const selectIsNotFirstFloorFilter = createSelector(selectIsFirstFloor, value => ({
  label: 'Не первый',
  value: value === false,
}));
